<template>
  <div class="enterprise">
    <div class="enterpriseTop">
      <img
        src="@/assets/enterprise-solution-title.png"
        alt=""
        class="enterpriseTitleImg"
      />
      <div class="enterpriseQuestions">
        <div>1.个税分红如何优化?</div>
        <div>2.企业利润虚高怎么办?</div>
        <div>3.公转私怎么合理安全?</div>
        <div>4.企业面临的无票多怎么办?</div>
        <div>5.企业用工成本过高怎么办?</div>
        <div>6.居间费/佣金结算无成本怎么办?</div>
      </div>
      <div class="enterpriseForm">
        <div class="formTitle">企业免费申请</div>
        <div class="formItem">
          <div class="label"><span>*</span> 公司名称</div>
          <input
            type="text"
            v-model="companyName"
            placeholder="例如：浙江省阿里巴巴控股有限公司"
          />
        </div>
        <div class="formItem">
          <div class="label"><span>*</span> 联系人</div>
          <input type="text" v-model="contactPerson" placeholder="例如：李XX" />
        </div>
        <div class="formItem">
          <div class="label"><span>*</span> 联系方式</div>
          <input
            type="text"
            v-model="contactPhone"
            placeholder="例如：0571-88888888；12200008888"
          />
        </div>
        <div class="formActions">
          <button class="cancelBtn" type="button">取消</button>
          <button class="submitBtn" type="button" @click="submit">提交</button>
        </div>
      </div>
    </div>
    <div class="enterprisetwin">
      <div v-for="(item, index) in twinList" :key="index" class="twinEvery">
        <img :src="item.url" alt="" v-if="item.type == 'left'" />
        <div class="text">{{ item.text }}</div>
        <img :src="item.url" alt="" v-if="item.type == 'right'" />
      </div>
    </div>
    <div class="enterpriseThree">
      <div v-for="(item, index) in plusList" :key="index" class="every">
        <img :src="item.url" alt="" />
        <div class="tilte">{{ item.tilte }}</div>
        <div class="texts">{{ item.text }}</div>
      </div>
    </div>
    <div class="enterpriseFooter">
      <img src="@/assets/Slice27.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      companyName: "",
      contactPerson: "",
      contactPhone: "",
      twinList: [
        {
          url: require("@/assets/image.png"),
          text: "中小企业或者个体经营单位，没有能力建立或健全和安全生产管理制度，经济实力不足，导致安全管理投入不足，违章作业频发，导致“三隐患”（管理隐患、物的隐患、人的隐患）状态",
          type: "left",
        },
        {
          url: require("@/assets/image_97.png"),
          text: "无证、假证上岗，流动作业，安全事故隐患大",
          type: "right",
        },
      ],
      plusList: [
        {
          url: require("@/assets/Mask2_group.png"),
          tilte: "用工管理平台",
          text: "提高劳务招聘效率，通过平台的智能匹配功能，企业能在短时间内找到合适的技能人才，相比传统招聘方式，招聘周期大幅缩短。",
        },
        {
          url: require("@/assets/Slices.png"),
          tilte: "合规与风险管理",
          text: "按小时、任务或项目自动计算薪酬。代扣代缴个人所得税，生成税务报表。提供劳动法相关的咨询服务。为灵活工作者提供工伤保险等，降低用工风险。确保用工流程符合当地法律法规。",
        },
        {
          url: require("@/assets/Mask4_group.png"),
          tilte: "‌加强作业安全管理",
          text: "三方监管、过程控制，管理追责，在资质审核上严格把关，有效减少安全事故风险，降低企业因安全事故带来的经济损失。",
        },
        {
          url: require("@/assets/Slices2.png"),
          tilte: "优化劳务管理流程",
          text: "平台提供的一体化管理功能，使企业的劳务管理更加规范化、信息化，提升管理效率和决策科学性。企业可以根据平台提供的数据统计和分析，合理安排劳务资源，降低劳务成本。",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    submit() {
      this.companyName = "";
      this.contactPerson = "";
      this.contactPhone = "";
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.enterpriseTop {
  width: 100%;
  height: 884px;
  background: url("@/assets/enterprise-solution-banner.png") center top / 1920px
    884px no-repeat;
  position: absolute;
  top: 0;
  .enterpriseTitleImg {
    width: 300px;
    height: 100px;
    position: absolute;
    left: 270px;
    top: 236px;
  }
  .enterpriseQuestions {
    position: absolute;
    left: 300px;
    top: 430px;
    font-weight: 400;
    font-size: 24px;
    color: #141414;
    line-height: 64px;
    text-align: left;
  }
  .enterpriseForm {
    position: absolute;
    left: 932px;
    top: 240px;
    width: 760px;
    height: 560px;
    box-sizing: border-box;
    padding: 52px 90px;
    background: #ffffff;
    text-align: left;
  }
  .formTitle {
    font-weight: 600;
    font-size: 28px;
    color: #141414;
    line-height: 40px;
    margin-bottom: 32px;
  }
  .formItem {
    margin-bottom: 28px;
  }
  .label {
    font-weight: 400;
    font-size: 14px;
    color: #141414;
    line-height: 22px;
    margin-bottom: 10px;
    span {
      color: #d9001b;
      margin-right: 4px;
    }
  }
  input {
    width: 100%;
    height: 46px;
    box-sizing: border-box;
    border: 1px solid #e4e7ed;
    padding: 0 20px;
    outline: none;
    font-size: 14px;
    color: #141414;
    &::placeholder {
      color: #c0c4cc;
    }
  }
  .formActions {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }
  button {
    width: 120px;
    height: 46px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  .cancelBtn {
    margin-right: 40px;
    border: 1px solid #e4e7ed;
    background: #ffffff;
    color: #141414;
  }
  .submitBtn {
    border: none;
    background: #1c87ff;
    color: #ffffff;
  }
}
.enterprisetwin {
  margin-top: 750px;
  padding: 100px 206px 0 206px;
  .twinEvery {
    display: flex;
    align-items: center;
    text-align: left;
    margin-bottom: 130px;
    img {
      width: 750px;
      height: 400px;
    }
    .text {
      width: 570px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #141414;
      line-height: 64px;
    }
  }
}

.enterpriseThree {
  background: #f4f7fc;
  padding: 120px 360px;
  display: flex;
  .every {
    width: 280px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(140, 140, 140, 0.25);
    border-radius: 24px 24px 24px 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    line-height: 32px;
    padding: 88px 40px 42px 40px;
    text-align: left;
    position: relative;
    margin-right: 22px;
    .tilte {
      font-weight: 500;
      font-size: 20px;
      color: #141414;
      padding-bottom: 56px;
      border-bottom: 1px solid #e4e7ed;
      text-align: center;
    }
    .texts {
      margin-top: 30px;
    }
    img {
      width: 136px;
      height: 136px;
      position: absolute;
      top: -78px;
      left: 72px;
    }
  }
}
.enterpriseFooter {
  background: #ffffff;
}

@media (max-width: 750px) {
  .enterprisetwin {
    margin-top: 750px;
    padding: 100px 100px 0 100px;
  }
  .enterpriseThree {
    padding: 120px 160px;
  }
  .enterpriseFooter {
    img {
      width: 100%;
      height: 990px;
    }
  }
}
</style>
